// extracted by mini-css-extract-plugin
export default {"menu":"settings_menu__C+Lg1"};